<template>
  <v-container class="recipe-editor-container">
    <v-alert
      prominent
      text
      type="warning"
      v-if="
        product &&
          product.data &&
          product.data.need_configuration === true &&
          dialog !== true
      "
    >
      <span>
        Ce produit a été créé dans une autre succursale. Les données concernant
        l'inventaire & les prix ont été automatiquement copié mais il se
        pourrait que des modifications soient nécessaire pour bien être adapté à
        cette succursale. Si aucune modification est nécessaire simplement,
        enregistrer la recette.</span
      >
    </v-alert>
    <v-row justify="space-between" no-gutters v-if="dialog !== true">
      <v-btn exact text :to="{ name: 'RecipeProductsIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
      <v-row align="center" justify="end" no-gutters v-if="id !== null">
        <RecipeKeyInput
          v-if="product && product.data"
          v-model="product.data.product_key"
        ></RecipeKeyInput>
        <v-tooltip left v-if="product && product.data">
          <template v-slot:activator="{ on }">
            <v-btn
              small
              v-on="on"
              icon
              text
              :color="product.data.is_pinned === true ? 'success' : ''"
              @click="product.data.is_pinned = !product.data.is_pinned"
            >
              <v-icon small>fa-eye</v-icon>
            </v-btn>
          </template>
          Surveiller ce produit
        </v-tooltip>
        <v-btn
          small
          icon
          text
          v-if="product && !product.est_intermediaire"
          v-show="!product.is_deleted"
          @click="deleteProduct"
        >
          <v-hover v-slot:default="{ hover }">
            <v-icon small :color="hover ? 'error' : ''">fa-trash</v-icon>
          </v-hover>
        </v-btn>
        <v-btn
          small
          icon
          text
          v-if="product && !product.est_intermediaire"
          v-show="product.is_deleted"
          @click="restoreProduct"
        >
          <v-hover v-slot:default="{ hover }">
            <v-icon small :color="hover ? 'success' : ''"
              >fa-trash-restore</v-icon
            >
          </v-hover>
        </v-btn>
      </v-row>
    </v-row>
    <section class="editor" v-if="product && product.data">
      <v-row justify="space-between" align="center" class="my-1">
        <v-col cols="12">
          <RecipeTagsEditor v-model="product.data.tags"></RecipeTagsEditor>
        </v-col>
      </v-row>
      <v-row align="center" class="my-1">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <v-text-field
                v-model="product.nom"
                filled
                dense
                label="Nom du produit"
                class="no-before"
                hide-details="auto"
              >
              </v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-tabs
        show-arrows
        slider-color="primary"
        v-model="tabs"
        background-color="transparent"
        class="mb-3"
      >
        <v-tab>
          <span
            :class="{
              'warning--text': product.data.need_configuration === true
            }"
            >Prix</span
          >
        </v-tab>
        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipeProductPriceInput
                v-bind.sync="product.data"
                :valid.sync="validPrice"
              ></RecipeProductPriceInput>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab>
          Informations
        </v-tab>
        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipeProductFields
                :nom.sync="product.nom"
                :est_intermediaire.sync="product.est_intermediaire"
                v-bind.sync="product.data"
                :valid.sync="valid"
              ></RecipeProductFields>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab>Expiration</v-tab>
        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <ProductExpirationFields
                :use_expiration_date.sync="product.use_expiration_date"
                :expiration_date_timer.sync="product.expiration_date_timer"
                :expiration_date_threshold.sync="
                  product.expiration_date_threshold
                "
                :use_auto_expiration_waste.sync="
                  product.use_auto_expiration_waste
                "
                :valid.sync="validExpiration"
              ></ProductExpirationFields>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab>Utilisations</v-tab>
        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <ProductRecipeLinkGrid :id="id"></ProductRecipeLinkGrid>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-row align="center" justify="end" class="my-3" no-gutters>
        <v-btn
          class="mr-0"
          color="success"
          :block="$vuetify.breakpoint.xsOnly"
          :disabled="getFormIsValid === false"
          @click="saveHandler"
        >
          <v-icon small left>fa-save</v-icon>
          <span>Enregistrer</span>
        </v-btn>
      </v-row>
    </section>
    <v-row
      v-else
      align="center"
      justify="center"
      no-gutters
      style="margin-top: 25vh;"
    >
      <v-progress-circular indeterminate></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { rulesMixin } from "@/mixins/rulesMixins";
import {
  RecipeProductFields,
  RecipeTagsEditor,
  RecipeProductPriceInput,
  RecipeKeyInput
} from "../components";
import ProductExpirationFields from "../components/ProductExpirationFields";
export default {
  mixins: [rulesMixin],
  name: "RecipeProductEditor",
  components: {
    RecipeProductFields,
    RecipeTagsEditor,
    RecipeProductPriceInput,
    RecipeKeyInput,
    ProductExpirationFields
  },
  props: {
    id: {
      default: null
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate(to, from, next) {
    await this.getData();
    next();
  },
  async beforeRouteLeave(to, from, next) {
    if (this.productChanged === true) {
      const res = await this.$dialog.confirm({
        text:
          "Voulez-vous enregistrer les modifications avant de quitter la page?",
        title: "",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      this.productChanged = false;
      if (res === true) {
        await this.saveHandler();
      }
    }
    next();
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getAuthHeader",
      "getAllowedUnits",
      "getIntermediateRecipe",
      "getOrganisationId"
    ]),
    getCurrentIntermediateRecipe() {
      return this.getIntermediateRecipe.find(
        r => r.fk_produit_intermediaire == this.id
      );
    },
    getFormIsValid() {
      return (
        this.valid === true &&
        this.validPrice === true &&
        this.validExpiration === true
      );
    }
  },
  data() {
    return {
      product: null,
      valid: false,
      validPrice: false,
      validExpiration: false,
      tabs: 0,
      productChanged: false
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        this.$store.dispatch("loadTagCategories");
        this.$store.dispatch("loadGlobalSuppliers");
        if (this.id !== null) {
          const product = await api.retrieveRecipeProduct(this.id);
          if (product.data === null) {
            product.data = {
              fk_product: this.id,
              store: this.getStoreId,
              tags: [],
              unite_mesure: null,
              unite_mesure_inventory: null,
              prix: 0,
              prix_inventory: 0,
              display_order: null,
              order_name: null,
              order_number: null,
              allergens: [],
              conversion_formula: null,
              use_conversion_formula: false,
              product_key: null,
              quantity_inventory: 1,
              quantity_production: null,
              use_order_quantity: false,
              price_order: null,
              quantity_order: null,
              quantity_inventory_order: null,
              unite_mesure_order: null,
              is_pinned: false,
              supplier_product_link: null,
              supplier_product_link_name: null,
              use_alternative_unit: false,
              alternative_quantity_production: null,
              alternative_quantity_inventory: 1,
              alternative_unite_mesure_production: null
            };
          } else if (product.data.need_configuration === true) {
            this.tabs = 1;
          }
          this.product = product;
        } else {
          this.product = {
            est_intermediaire: false,
            is_deleted: false,
            nom: null,
            data: {
              fk_product: null,
              store: null,
              tags: [],
              unite_mesure: null,
              unite_mesure_inventory: null,
              prix: 0,
              prix_inventory: 0,
              display_order: null,
              order_name: null,
              order_number: null,
              allergens: [],
              conversion_formula: null,
              use_conversion_formula: false,
              product_key: null,
              quantity_inventory: 1,
              quantity_production: null,
              use_order_quantity: false,
              price_order: null,
              quantity_order: null,
              quantity_inventory_order: null,
              unite_mesure_order: null,
              is_pinned: false,
              supplier_product_link: null,
              supplier_product_link_name: null,
              use_alternative_unit: false,
              alternative_quantity_production: null,
              alternative_quantity_inventory: 1,
              alternative_unite_mesure_production: null
            }
          };
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async saveHandler() {
      if (this.id !== null) {
        await this.updateProduct();
      } else {
        await this.postProduct();
      }
    },
    async postProduct() {
      if (this.getFormIsValid === true) {
        try {
          this.$store.dispatch("startLoadingOverlay");
          const data = {
            ...this.product,
            organisation: this.getOrganisationId
          };
          data.data.store = this.getStoreId;
          await api.postRecipeProduct(data);
          this.productChanged = false;
          if (this.dialog !== true)
            this.$router.push({ name: "RecipeProductsIndex" });
          this.$emit("save");
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async updateProduct() {
      if (this.getFormIsValid === true) {
        try {
          this.$store.dispatch("slo");
          const data = {
            ...this.product
          };
          data.data.fk_product = this.id;
          data.data.store = this.getStoreId;
          await api.patchRecipeProduct(this.id, data);
          this.productChanged = false;
          if (this.dialog !== true)
            this.$router.push({ name: "RecipeProductsIndex" });
          this.$emit("save");
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async deleteProduct() {
      const confirm = await this.$dialog.warning({
        title: "Supprimer",
        text: "Êtes-vous certain de vouloir supprimer ce produit?",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      if (confirm === true) {
        try {
          this.$store.dispatch("startLoadingOverlay");
          this.product.is_deleted = true;
          await this.updateProduct();
          this.$emit("delete");
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async restoreProduct() {
      const confirm = await this.$dialog.warning({
        title: "Restauration",
        text: "Êtes-vous certain de vouloir restaurer ce produit?",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      if (confirm === true) {
        try {
          this.$store.dispatch("startLoadingOverlay");
          this.product.is_deleted = false;
          await this.updateProduct();
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    productChangeHandler(nV, oV) {
      if (oV !== undefined && oV !== null) {
        this.productChanged = true;
      }
    }
  },
  watch: {
    product: {
      deep: true,
      handler: "productChangeHandler"
    }
  }
};
</script>

<style lang="scss" scoped></style>
